export default __webpack_public_path__ + "d46d60aed7f484339e9b1ba65eb4010a.svg";